import { saveAs } from "file-saver";

const EXT_BY_MIME = {
  "application/pdf": "pdf",
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "image/gif": "gif",
};

const FILE_EXTENSION_PATTERN = /\.[a-z0-9]{2,8}$/i;

const getBaseName = (value) => {
  if (!value) return "";
  return String(value).split("?")[0].split("/").pop() || "";
};

const hasFileExtension = (fileName) => FILE_EXTENSION_PATTERN.test(fileName);

const extensionFromMime = (mimeType) => {
  if (!mimeType) return "";
  const normalized = String(mimeType).split(";")[0].trim().toLowerCase();
  return EXT_BY_MIME[normalized] || "";
};

const extensionFromUrl = (url) => {
  if (!url) return "";
  const match = String(url)
    .toLowerCase()
    .match(/\.([a-z0-9]{2,8})(?:\?|$)/);
  return match ? match[1] : "";
};

/**
 * Ensures the download filename includes a real extension so OS/apps open PDFs/images correctly.
 */
export const resolveDownloadFileName = (
  storedName,
  fallbackName = "document",
  mimeOrUrl = ""
) => {
  const storedBaseName = getBaseName(storedName);
  if (hasFileExtension(storedBaseName)) {
    return storedBaseName;
  }

  const fallbackBaseName = getBaseName(fallbackName) || "document";
  if (hasFileExtension(fallbackBaseName)) {
    return fallbackBaseName;
  }

  const extension =
    extensionFromMime(mimeOrUrl) || extensionFromUrl(mimeOrUrl) || "bin";

  return `${fallbackBaseName}.${extension}`;
};

/**
 * Downloads a media file from REACT_APP_MEDIA_URL with a filename that always has an extension.
 */
export const downloadMediaFile = async ({
  mediaBaseUrl,
  storedName,
  fallbackName = "document",
}) => {
  if (!storedName) {
    return;
  }

  const url = `${mediaBaseUrl}/${storedName}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Download failed (${response.status})`);
    }

    const blob = await response.blob();
    const fileName = resolveDownloadFileName(
      storedName,
      fallbackName,
      blob.type || url
    );
    saveAs(blob, fileName);
  } catch {
    const fileName = resolveDownloadFileName(storedName, fallbackName, url);
    saveAs(url, fileName);
  }
};
